import axios, { AxiosPromise } from 'axios'

export interface ImpressaoFichaSinanInput {
  idNotificacao: string
  cidadaoId: number
  dataAtendimento: Instant
}

export class FichaSinan {
  gerarFichaSinan(input: ImpressaoFichaSinanInput): AxiosPromise<Blob> {
    return axios.post('/api/atendimento/gerarFichaSinan', input, { responseType: 'blob' })
  }
}
